// extracted by mini-css-extract-plugin
export var changeIcon = "_3t-4";
export var container = "_3t-0";
export var divider = "_3t-7";
export var externalLinkIcon = "_3t-1";
export var green = "_3t-5";
export var helpCircleIcon = "_3t-3";
export var iconButton = "_3t-2";
export var red = "_3t-6";